import "core-js/stable"
import "regenerator-runtime/runtime"

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'

import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2'
import VConsole from 'vconsole'
import vueSwiper from 'vue-awesome-swiper'
import fastClick from 'fastclick'
import 'swiper/css/swiper.css'

import toast from './components/toast'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video

if (process.env.NODE_ENV === 'development') {
  new VConsole()
}
Vue.config.productionTip = false

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(VueLazyload, {
  loading: require('./assets/images/img_loading.jpg'),
  error: require('./assets/images/img_error.jpg')
})
Vue.use(VueClipboard)
Vue.use(vueSwiper)
Vue.use(require('vue-wechat-title'))
Vue.use(toast)
fastClick.attach(document.body)

const app = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

export default app
